import script from "./RecipePanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./RecipePanel.vue?vue&type=script&lang=ts&setup=true"

import "./RecipePanel.vue?vue&type=style&index=0&id=ee3a78b6&scoped=true&lang=css"

import exportComponent from "E:\\Marianne\\workspace\\notion-cooks\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ee3a78b6"]])

export default __exports__